import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { I18nService } from '../../core/services/i18n.service';
import { NotificationService } from '../../core/services/notification.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <div class="login-page">
      <div class="login-card">
        <div class="lang-switcher">
          <button type="button" [class.active]="i18n.currentLanguage() === 'en'" (click)="i18n.setLanguage('en')">{{ i18n.t('common.english') }}</button>
          <button type="button" [class.active]="i18n.currentLanguage() === 'ar'" (click)="i18n.setLanguage('ar')">{{ i18n.t('common.arabic') }}</button>
        </div>
        <h1>{{ i18n.t('login.title') }}</h1>
        <form [formGroup]="form" (ngSubmit)="submit()">
          <label>{{ i18n.t('login.username') }}</label>
          <input type="text" formControlName="username" />

          <label>{{ i18n.t('login.password') }}</label>
          <input type="password" formControlName="password" />

          <button type="submit" [disabled]="loading">{{ loading ? i18n.t('login.submitting') : i18n.t('login.submit') }}</button>
        </form>
      </div>
    </div>
  `,
  styles: [`
    .login-page { min-height:100vh; display:flex; align-items:center; justify-content:center; background:#f3f4f6; padding:24px; }
    .login-card { width:380px; max-width:100%; background:#fff; padding:32px; border-radius:16px; box-shadow:0 10px 30px rgba(0,0,0,.08); }
    .lang-switcher { display:flex; justify-content:flex-end; gap:8px; margin-bottom:16px; }
    h1 { margin-bottom:20px; }
    form { display:flex; flex-direction:column; gap:12px; }
    input { height:42px; border:1px solid #d1d5db; border-radius:10px; padding:0 12px; }
    button { margin-top:8px; height:44px; border:0; border-radius:10px; background:#111827; color:#fff; cursor:pointer; }
    .lang-switcher button { margin-top:0; height:auto; padding:8px 12px; background:#fff; color:#111827; border:1px solid #d1d5db; }
    .lang-switcher button.active { background:#111827; color:#fff; border-color:#111827; }
  `]
})
export class LoginComponent {
  private readonly fb = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly notification = inject(NotificationService);

  readonly i18n = inject(I18nService);
  loading = false;

  form = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  submit(): void {
    if (this.form.invalid || this.loading) return;

    this.loading = true;

    this.authService.login(this.form.getRawValue() as { username: string; password: string; })
      .subscribe({
        next: () => {
          this.loading = false;
          this.router.navigate(['/archive']);
        },
        error: () => {
          this.loading = false;
          this.notification.error(this.i18n.t('login.invalidCredentials'));
        }
      });
  }
}
